import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useTranslation } from "../../hooks";
import { usePortalStore } from "../../store/portal/PortalStoreContext";
import { PortalLanding } from "./PortalLanding";
import { PortalDashboard } from "./PortalDashboard";
import { PortalRescheduleStep } from "./PortalRescheduleStep";
import { UnifiedBookingWidget } from "../unified/UnifiedBookingWidget";
export function PortalShell({ onError, maxHeight }) {
    const { t } = useTranslation("portal");
    const view = usePortalStore((s) => s.view);
    const exitBooking = usePortalStore((s) => s.exitBooking);
    const startReschedule = usePortalStore((s) => s.startReschedule);
    const channel = usePortalStore((s) => s.channel);
    const countryCode = usePortalStore((s) => s.countryCode);
    const phoneNumber = usePortalStore((s) => s.phoneNumber);
    const email = usePortalStore((s) => s.email);
    if (view === "phone" || view === "code") {
        return _jsx(PortalLanding, {});
    }
    if (view === "reschedule") {
        return _jsx(PortalRescheduleStep, {});
    }
    if (view === "booking") {
        return (_jsxs(Box, { children: [_jsx(Button, { onClick: exitBooking, startIcon: _jsx(ArrowBackRoundedIcon, { sx: { fontSize: 18 } }), sx: { mb: 2, px: 1, color: "text.secondary" }, children: t("backToAppointments", "Back to my appointments") }), _jsx(UnifiedBookingWidget, { onError: onError, maxHeight: maxHeight, verifiedPhone: channel === "email"
                        ? email
                            ? { channel: "email", email }
                            : undefined
                        : phoneNumber
                            ? { channel: "phone", countryCode, phoneNumber }
                            : undefined, onSuccess: exitBooking })] }));
    }
    return _jsx(PortalDashboard, { onReschedule: startReschedule });
}
